module.exports = __webpack_public_path__ + "img/tentang-kami.acfb26cc.jpg";